<template>
  <div class="content-page-dashboard-index">
    <div class="header">
      <span class="title">{{ $store.state.initialInfo.displayName || "--" }}的工作台</span>
      <div class="actions">
        <el-select v-if="callByAli" :disabled="stateDisabled" :value="state" @input="onStateInput">
          <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value" :disabled="
              item.enabledValues.indexOf($store.state.callState) === -1
            "></el-option>
        </el-select>
        <div v-else class="btn btn-normal" @click="agentLogon()">自动签入</div>
        <!-- <div class="btn btn-normal" @click="getcallState()">输出状态</div> -->
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(1)">
          服务下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(2)">
          订餐下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(3)">
          养老机构下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }"
          @click="currentUserPhone && createOrder(4)">
          日间照料中心下单
        </div>
        <div class="btn btn-normal" :class="{ disabled: !currentUserPhone }">
          添加投诉
        </div>
        <div class="btn btn-110" @click="dial('110')" :class="{ disabled: !isReady }">
          <i></i>110
        </div>
        <div class="btn btn-120" @click="dial('120')" :class="{ disabled: !isReady }">
          <i></i>120
        </div>
      </div>
      <div class="sound">
        <span>音量</span>
        <i class="iconfont iconyinliang1"></i>
        <el-slider :disabled="!isReady" v-model="volume"></el-slider>
        <i class="iconfont iconvolume-up"></i>
      </div>
    </div>
    <div class="body">
      <div class="left">
        <div id="ccbar"></div>
      </div>
      <div class="right">
        <information :call-number="callNumber" :inout="inout" @personPhone="getOlderPhone" />
      </div>
      <el-dialog v-if="callByAli" :visible.sync="showMobileDialog" center :show-close="false" width="500px">
        <el-form labelWidth="160px" labelPosition="left" size="mini">
          <el-form-item label="转接手机号码：">
            <el-input clearable v-model="mobileNumberStr"></el-input>
          </el-form-item>
          <el-button native-type="submit" center type="primary" @click.native="setMobileNumber()">确认</el-button>
          <el-button native-type="submit" center type="primary" plain @click.native="closeDialog">取消</el-button>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Information from "@/components/pages/dashboard/Information";
import qs from "qs";
export default {
  components: { Information },
  data() {
    return {
      callByAli: window.callByAli,
      state: 3,
      states: [
        { label: "挂起", value: 12, enabledValues: [9, 10, "TALK"] },
        { label: "取消挂起", value: -12, enabledValues: [12, "HELD"] },
        { label: "小休", value: 2, enabledValues: [3, "IDLE"] },
        { label: "接听来电", value: 3, enabledValues: [2, "BUSY"] },
        { label: "手机接听", value: 41, enabledValues: [3, "IDLE"] },
        { label: "下线", value: 1, enabledValues: [2, 3, "IDLE", "BUSY"] },
        { label: "仅外呼", value: 40, enabledValues: [3, "IDLE"] },
      ],
      volume: 50,
      olderPhone: "",
      showMobileDialog: false,
      mobileNumberStr: "",
    };
  },
  computed: {
    stateDisabled() {
      if (callByAli) {
        return [3, 2, 12].indexOf(this.$store.state.callState) === -1;
      } else {
        console.log(this.$store.state.callState);
        // return ["IDLE", "BUSY", "HELD"].indexOf(this.$store.state.callState) === -1
        return false;
      }
    },
    isReady() {
      if (callByAli) {
        return this.$store.state.callState > 2;
      } else {
        return (
          this.$store.state.callState != null &&
          this.$store.state.callState != "LOGOFF"
        );
      }
    },
    callNumber() {
      console.log(
        "currentUserPhone----" + JSON.stringify(this.currentUserPhone)
      );
      console.log(
        "callNumber----" + JSON.stringify(this.$store.state.callInfo)
      );
      if (this.$store.state.callInfo.inout === "in")
        return this.$store.state.callInfo.caller;
      else if (this.$store.state.callInfo.inout === "out")
        return this.$store.state.callInfo.callee;
      else return null;
    },
    inout() {
      return this.$store.state.callInfo.inout;
    },
  },
  mounted() {
    if (this.$store.state.want2call) {
      console.log("want2call:" + this.$store.state.want2call);
      if (callByAli && this.$store.state.callState == 3) {
        window.workbench.call(this.$store.state.want2call, "");
        this.$store.commit("setWant2call", "");
      } else if (!callByAli && this.$store.state.callState == "IDLE") {
        CallControl.workMode("outbound", function (result) {
          console.log(result);
        }); //inbound呼入,outbound呼出
        ccbarsdk.makecall(this.$store.state.want2call, "", function (res) {}); //被叫号码,外显号码,通过CallControl.callerList获取或填""自动取技能组配置的号码
        this.$store.commit("setWant2call", "");
      }
    }
    this.$store.dispatch("initWorkbench");
  },
  watch: {
    "$store.state.callState"(val, oldVal) {
      if (val === 3) {
        this.state = 3;
        if (this.$store.state.want2call) {
          window.workbench.call(this.$store.state.want2call, "");
          this.$store.commit("setWant2call", "");
        }
      } else if (val === "IDLE") {
        if (this.$store.state.want2call) {
          CallControl.workMode("outbound", function (result) {
            console.log(result);
          }); //inbound呼入,outbound呼出
          ccbarsdk.makecall(this.$store.state.want2call, "", function (res) {}); //被叫号码,外显号码,通过CallControl.callerList获取或填""自动取技能组配置的号码
          this.$store.commit("setWant2call", "");
        }
      } else if ((oldVal == 3 && (val == 8 || val == 6)) || oldVal == "IDLE") {
        console.log("$store.state.callState", val, oldVal);
        this.setCallStatus();
      }
    },
    "$store.state.callInfo"(val) {
      if (val.inout) {
      } else {
      }
    },
    "$store.state.handleClearcall"(val) {
      this.Service.call("callworkOrder", "POST", qs.stringify(val)).then(
        (data) => {
          console.log(data);
        }
      );
    },
    volume(val) {
      window.workbench.changeVolumeInCall(val / 100);
    },
  },
  methods: {
    getcallState() {
      console.log(this.$store.state.callState);
    },
    agentLogon() {
      if (!CallControl.isLogoned) {
        this.Service.call("userbindAgent/byusergid", "GET", {
          userGid: this.$store.state.auth.userGid,
        }).then((data) => {
          // let entId = '1013'; //企业ID，由云呼平台提供
          // let loginKey = 'YK9EYKT53DNR2JKE4FHPXKEF9U211P0Y'; //登录密钥，32位长度，由云呼平台提供
          // let productId = '003'; //企业订购的产品，由云呼平台提供
          let agentId = data.agentNo;
          let agentPwd = data.agentPwd; //hex_md5(agentPwd)
          let phone = data.number;
          CallControl.agentLogon(
            "1010",
            "5ZGSJWZF1ZDP6BRKY8I1ZE3E106BSEF8",
            "003",
            agentId,
            agentPwd,
            phone,
            function (res) {
              console.log("自动签入:" + JSON.stringify(res));
            }
          );
        });
      }
    },
    getOlderPhone(val) {
      this.olderPhone = val;
    },
    onStateInput(val) {
      try {
        switch (val) {
          case 12:
            if (window.callByAli) {
              window.workbench.callHold();
            } else {
              CallControl.holdCall();
            }
            break;
          case -12:
            if (window.callByAli) {
              window.workbench.callRetrieve();
            } else {
              CallControl.unholdCall();
            }
            break;
          case 2:
            if (window.callByAli) {
              window.workbench.applyForBreak(5, "临时有事");
            } else {
              CallControl.agentNotReady();
            }
            break;
          case 41:
            this.showMobileDialog = true;
            break;
          case 40:
            if (callByAli) {
              window.workbench.applyForCallOnly(true);
            } else {
              CallControl.workMode("outbound", function (result) {
                console.log(result);
              });
            }
            break;
          case 3:
            if (callByAli) {
              window.workbench.ready();
            } else {
              CallControl.agentReady();
            }
            break;
          case 1:
            if (callByAli) {
              window.workbench.logOut();
            } else {
              CallControl.logoff(function (result) {
                try {
                  if (result.state != "1") {
                    tipsMsg(result.msg);
                  }
                } catch (e) {}
              });
            }
            break;
        }
        this.state = val;
      } catch (e) {}
    },
    dial(num) {
      if (callByAli) {
        window.workbench.call(num);
      } else {
        ccbarsdk.makecall(num, ""); //外呼 被叫号码和外显号码,外显号码通过CallControl.callerList获取,如caller传''则外呼时自动取坐席对应的外显号码
      }
    },
    setMobileNumber() {
      if (!this.mobileNumberStr) {
        this.$message.error("手机号不能为空");
      } else if (!/^1[123456789]\d{9}$/.test(this.mobileNumberStr)) {
        this.$message.error("请输入正确的手机号");
      } else {
        window.workbench.offline(this.mobileNumberStr);
        this.showMobileDialog = false;
      }
    },
    closeDialog() {
      this.state = 3;
      this.showMobileDialog = false;
    },
    setCallStatus() {
      let para = {
        CallId: this.$store.state.callInfo.jobId,
        ContactId: this.$store.state.callInfo.jobId,
        CalledNumber: this.$store.state.callInfo.callee,
        CallingNumber: this.$store.state.callInfo.caller,
        ContactType:
          this.$store.state.callInfo.inout === "in"
            ? "Inbound"
            : this.$store.state.callInfo.inout === "out"
            ? "Outbound"
            : "Internal",
      };
      if (this.$store.state.callReason) {
        let callReason = JSON.parse(this.$store.state.callReason);
        if (callReason.reason == "losscall") {
          this.Service.call("callrecord/noanswer/status", "GET", {
            contactId: callReason.contactId,
          }).then((res) => {
            this.$store.commit("setCallReason", "");
          });
        } else if (
          callReason.reason == "alarmorder" ||
          callReason.reason == "planorder"
        ) {
          para.WorkOrderId = callReason.gid;
        }
      }
      orderCallRecordApi.oncall(para).then((res) => {
        this.$store.commit("setCallReason", "");
      });
    },
  },
};
</script>
